import { apiRequest } from '@/core';
import { type Logo } from '@/slices/logos/types';
import { type PaginatedResponse } from '@/types';

export const fetchLogoCollectionRequest = async ({
  search,
}: {
  search?: string;
}) =>
  apiRequest<PaginatedResponse<Logo>>({
    endpoint: `api/logos/collection`,
    params: {
      search,
    },
  });
